export const GET_LOCKERS_CALENDAR = 'GET_LOCKERS_CALENDAR';
export const GET_LOCKERS_CALENDAR_SUCCESS = 'GET_LOCKERS_CALENDAR_SUCCESS';
export const GET_LOCKERS_CALENDAR_ERROR = 'GET_LOCKERS_CALENDAR_ERROR';

export const GET_LOCKER_CALENDAR = 'GET_LOCKER_CALENDAR';
export const GET_LOCKER_CALENDAR_SUCCESS = 'GET_LOCKER_CALENDAR_SUCCESS';
export const GET_LOCKER_CALENDAR_ERROR = 'GET_LOCKER_CALENDAR_ERROR';

export const OPEN_CREATE_NEW_APPOINTMENT_MODAL = 'OPEN_CREATE_NEW_APPOINTMENT_MODAL';
export const CLOSE_CREATE_NEW_APPOINTMENT_MODAL = 'CLOSE_CREATE_NEW_APPOINTMENT_MODAL';

export const SET_SELECTED_LOCKER_ID = 'PLANNING/SET_SELECTED_LOCKER_ID';

export const SET_PLANNING_FILTER = 'PLANNING/SET_FILTER';
export const SET_PLANNING_FILTERS = 'PLANNING/SET_FILTERS';
export const CLEAR_PLANNING_FILTERS = 'PLANNING/CLEAR_FILTERS';
export const REMOVE_PLANNING_FILTER = 'PLANNING/REMOVE_FILTER';
export const INCREMENT_SELECTED_DAY = 'PLANNING/INCREMENT_SELECTED_DAY';
export const DECREMENT_SELECTED_DAY = 'PLANNING/DECREMENT_SELECTED_DAY';
export const SET_SELECTED_DAY = 'PLANNING/SET_SELECTED_DAY';

export const PERSISTED_ACTION_TYPES = [SET_PLANNING_FILTER, SET_PLANNING_FILTERS, CLEAR_PLANNING_FILTERS, REMOVE_PLANNING_FILTER];
